<template>
  <div class="auth-layout">
    <RouterView />
  </div>
</template>

<script lang="ts" setup>
/**
 * @component AuthLayout
 * @description Simple layout wrapper for auth pages (login, signup, etc.)
 * The pages themselves handle their full-page design.
 */
</script>

<style scoped>
.auth-layout {
  min-height: 100vh;
  min-height: 100dvh;
}
</style>
